import React from 'react';
import { Flex } from '@chakra-ui/react';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import { Button } from '../button/button';
import { CoderCount } from '../coder-count/CoderCount';
import { ButtonVariant } from '../../core/enums';

export interface QueueCardRow2Props {
  coderCount: number;
  onManageCoders?: () => void;
  onHealthTargets?: () => void;
  onForecasting?: () => void;
}

export const QueueCardRow2: React.FC<QueueCardRow2Props> = ({
  coderCount,
  onManageCoders,
  onHealthTargets,
  onForecasting
}) => {
  return (
    <Flex
      className="cmx-queue-card-row2"
      alignItems="center"
      gap="6"
      data-testid="queue-card-row2"
    >
      <CoderCount count={coderCount} />
      <Flex gap="3">
        <Button
          label="Manage Coders"
          variant={ButtonVariant.SECONDARY}
          onClick={onManageCoders}
          leftIcon={<BiomeIcon iconName={IconName.User} />}
          dataTestId="btn-manage-coders"
        />
        {/* CDMX-TODO: Health Targets not yet scoped
        <Button
          label="Health Targets"
          variant={ButtonVariant.SECONDARY}
          onClick={onHealthTargets}
          leftIcon={<BiomeIcon iconName={IconName.Reports} />}
          dataTestId="btn-health-targets"
        />
        */}
        {/* CDMX-TODO: Forecasting not yet scoped
        <Button
          label="Forecasting"
          variant={ButtonVariant.SECONDARY}
          onClick={onForecasting}
          leftIcon={<BiomeIcon iconName={IconName.Calendar} />}
          dataTestId="btn-forecasting"
        />
        */}
      </Flex>
    </Flex>
  );
};

QueueCardRow2.displayName = 'QueueCardRow2';
export default QueueCardRow2;
